import { Formik } from "formik";
import React from "react";
import { Form } from "react-bootstrap";
import { Button} from '@blueprint/ui';
import * as yup from "yup";

import {
    FileField,
    FormFooter,
    TextareaField,
} from "../../../common/components/form";
import { MaxTotalFileSize } from "../../../misc/validators";
import {
    FormSubmissionHandler,
    ISODate,
    UploadedFileWithSize,
} from "../../../types/common";

export type ClaimFormValues = {
    createdAt?: ISODate;
    description: string;
    files: UploadedFileWithSize[];
};

const schema = yup.object().shape({
    description: yup.string().required(),
    files: yup.array().min(1, "Upload file is required").test(MaxTotalFileSize),
});

type ClaimFormProps = {
    values?: ClaimFormValues;
    onCancel: () => void;
    onSubmit: FormSubmissionHandler<ClaimFormValues>;
};

const ClaimForm = ({
    values,
    onCancel,
    onSubmit,
}: ClaimFormProps): JSX.Element => {
    return (
        <Formik
            validationSchema={schema}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={onSubmit}
            initialValues={
                values || {
                    description: "",
                    files: [],
                }
            }
        >
            {({ handleSubmit }) => (
                <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                    <TextareaField
                        name="description"
                        label="Claim Description"
                        maxLength={256}
                        isAllowed={(formattedValue) => formattedValue.length < 256}
                        autoFocus
                        required={true}
                        defaultValue={values?.description}
                    />
                    <hr className="bg-border-grey my-3" />
                    <h1 className="mt-3 mb-3 rem-1-5">Add Documents</h1>
                    <FileField name="files" required={true}/>
                    <hr className="bg-border-grey my-3" />
                    <FormFooter className="d-flex justify-content-between">
                        <Button variant="light.tertiary" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button variant="light.primary" type="submit">
                            Next
                        </Button>
                    </FormFooter>
                </Form>
            )}
        </Formik>
    );
};

export default ClaimForm;
